import { createFileRoute, redirect } from '@tanstack/react-router'
import { PaymentTermsScreen } from '@/features/accounting-tax/payment-terms-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/accounting/payment-terms')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_settings.edit'))
      throw redirect({ to: '/accounting' })
  },
  component: PaymentTermsScreen,
})
